// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: 'cac664d2-e512-4f83-86a9-d2732c24c4c0',
      type: 'Sprite',
      runtimeType: null,
      name: 'tileDarkness',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tile_dark',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'e54fc012-b206-4c27-99cd-73d0b9fdf80c',
      type: 'Container',
      runtimeType: null,
      name: 'lockAndChainContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '9bae2bea-19ec-49c4-9cc4-19fb5340feb0',
      type: 'Sprite',
      runtimeType: null,
      name: 'tileHighlight',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tile_hover',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'aeca96d2-0f92-47a0-bf33-aae7a6913c20',
      type: 'Text',
      runtimeType: null,
      name: 'scoreText',
      className: '',
      x: 2,
      y: -38,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '10',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '718a029c-e814-4f85-af5e-5d6f56df82be',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -41,
      y: -14,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bottom_Chain',
      parent: 'e54fc012-b206-4c27-99cd-73d0b9fdf80c',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'aea1ac94-38f7-41bb-9873-782dcf9263a7',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 40,
      y: -14,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bottom_Chain',
      parent: 'e54fc012-b206-4c27-99cd-73d0b9fdf80c',
      data: undefined,
      stateByName: {}
    },
    {
      id: '4dd56ce7-997a-4126-9120-3bf82c7900f3',
      type: 'Container',
      runtimeType: null,
      name: 'lockContainer',
      className: '',
      x: 0,
      y: 1,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: -3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e54fc012-b206-4c27-99cd-73d0b9fdf80c',
      data: undefined,
      stateByName: {}
    },
    {
      id: '044bd9b6-7afc-4521-9b06-2bf46ab4124f',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -61,
      y: -29,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Top_Chain',
      parent: 'e54fc012-b206-4c27-99cd-73d0b9fdf80c',
      data: undefined,
      stateByName: {}
    },
    {
      id: '80173fb7-b106-462c-8a19-256d3091443e',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 60,
      y: -29,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Top_Chain',
      parent: 'e54fc012-b206-4c27-99cd-73d0b9fdf80c',
      data: undefined,
      stateByName: {}
    },
    {
      id: '3f30208e-906d-4d59-a158-f0b53642b942',
      type: 'Container',
      runtimeType: null,
      name: 'lockHook',
      className: '',
      x: 1,
      y: 38,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4dd56ce7-997a-4126-9120-3bf82c7900f3',
      data: undefined,
      stateByName: {}
    },
    {
      id: '6971f82a-b71e-45f4-bb7c-9c92bfe96f92',
      type: 'Container',
      runtimeType: null,
      name: 'lockBody',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4dd56ce7-997a-4126-9120-3bf82c7900f3',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'cbf7282b-5d5d-4f44-89dc-9c75433407cb',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lock_Hook',
      parent: '3f30208e-906d-4d59-a158-f0b53642b942',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'f69f9bff-5814-4b61-bf12-68d67760776f',
      type: 'Sprite',
      runtimeType: null,
      name: 'lockHookHighlight',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lock_Hook',
      parent: '3f30208e-906d-4d59-a158-f0b53642b942',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'fe301b7d-4ecb-446e-99b0-53b564f44ee4',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lock',
      parent: '6971f82a-b71e-45f4-bb7c-9c92bfe96f92',
      data: undefined,
      stateByName: {}
    },
    {
      id: '6eae3ed4-1bbb-4b5b-acfe-b08acec6c3dc',
      type: 'Sprite',
      runtimeType: null,
      name: 'lockBodyHighlight',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lock',
      parent: '6971f82a-b71e-45f4-bb7c-9c92bfe96f92',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class ScoreBlockerFieldLayout {
  static raw = raw;
  root: Container;
  tileDarkness: Sprite;
  lockAndChainContainer: Container;
  tileHighlight: Sprite;
  scoreText: Text;
  lockContainer: Container;
  lockHook: Container;
  lockBody: Container;
  lockHookHighlight: Sprite;
  lockBodyHighlight: Sprite;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      tileDarkness: typeof raw['list'][1];
      lockAndChainContainer: typeof raw['list'][2];
      tileHighlight: typeof raw['list'][3];
      scoreText: typeof raw['list'][4];
      lockContainer: typeof raw['list'][7];
      lockHook: typeof raw['list'][10];
      lockBody: typeof raw['list'][11];
      lockHookHighlight: typeof raw['list'][13];
      lockBodyHighlight: typeof raw['list'][15];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
